import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconWebsite = (props?: SvgProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <mask
      id="mask0_13937_33975"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="26"
      height="26"
    >
      <path d="M0 0H26V26H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_13937_33975)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0739 10.4C18.1519 11.2177 18.2 12.0796 18.2 13C18.2 13.3448 18.063 13.6755 17.8192 13.9192C17.5755 14.163 17.2448 14.3 16.9 14.3C16.5552 14.3 16.2245 14.163 15.9808 13.9192C15.737 13.6755 15.6 13.3448 15.6 13C15.6 12.0731 15.5493 11.2086 15.4635 10.4H10.5196C10.3389 12.1285 10.3372 13.8711 10.5144 15.6H13C13.3448 15.6 13.6755 15.737 13.9192 15.9808C14.163 16.2245 14.3 16.5552 14.3 16.9C14.3 17.2448 14.163 17.5755 13.9192 17.8192C13.6755 18.063 13.3448 18.2 13 18.2H10.9408C11.5505 20.904 12.5034 22.633 13.0013 23.4C13.0013 23.4 14.027 23.4169 14.2051 23.4026C14.5484 23.3804 14.8867 23.494 15.1469 23.7189C15.4072 23.9439 15.5685 24.2622 15.5961 24.6051C15.6212 24.9488 15.5087 25.2884 15.2835 25.5493C15.0582 25.8101 14.7386 25.9709 14.3949 25.9961C14.2727 26.0052 13 26 13 26C5.8318 26 0 20.1682 0 13C0 5.8305 5.8318 0 13 0C20.1682 0 26 5.8305 26 13C26 13.4927 25.9532 13.9737 25.8973 14.4508C25.8457 14.7836 25.6671 15.0834 25.399 15.2872C25.1309 15.4909 24.7942 15.583 24.4599 15.5437C24.1254 15.5045 23.8191 15.3371 23.6055 15.0769C23.3918 14.8166 23.2874 14.4836 23.3142 14.1479C23.3597 13.7696 23.4 13.39 23.4 13C23.4 12.1004 23.2726 11.232 23.0581 10.4H18.0739ZM12.9844 2.6468C12.4826 3.4346 11.5544 5.1571 10.9512 7.8H15.0293C14.4235 5.1571 13.4888 3.4346 12.9844 2.6468ZM2.9419 15.6H7.9066C7.8312 14.7823 7.7831 13.923 7.7831 13.0052C7.78393 12.1353 7.82557 11.266 7.9079 10.4H2.9419C2.7261 11.232 2.6 12.1004 2.6 13C2.60324 13.8776 2.71812 14.7514 2.9419 15.6ZM4.0066 18.2C5.29035 20.4148 7.34309 22.0808 9.7747 22.8813C9.09732 21.3841 8.59648 19.813 8.2823 18.2H4.0066ZM8.2849 7.8C8.6762 5.8487 9.2404 4.2861 9.7799 3.1161C7.34588 3.91602 5.29103 5.58312 4.0066 7.8H8.2849ZM17.6956 7.8H21.9921C20.7024 5.57268 18.6352 3.90042 16.1876 3.1044C16.8732 4.60482 17.3794 6.18093 17.6956 7.8Z"
        fill="black"
      />
      <path
        d="M19.7897 24.6291L16.4746 17.3358C16.226 16.789 16.7885 16.2266 17.3353 16.475L24.6286 19.7903C25.1263 20.0165 25.1393 20.7189 24.6503 20.9634L22.3858 22.0956C22.26 22.1585 22.1581 22.2605 22.0951 22.3863L20.9628 24.6509C20.7183 25.1399 20.016 25.1269 19.7897 24.6291Z"
        fill="black"
      />
    </g>
  </svg>
)
